module.exports = __webpack_public_path__ + "media/images/icon-doctor-9de36bfdac8a0f38bdcef4e8e2e47a8c.png";